import {
  UPLOAD_CLUB_GDPR_FILE,
  COMPLETE_CLUB_GDPR_UPLOAD,
  CANCEL_CLUB_GDPR_UPLOAD,
} from "../../../graphql/fileGraphql";

export async function uploadClubGdprDocument({ file, clubId, graphql, post = fetch, onCleanupError }) {
  const response = await graphql({
    query: UPLOAD_CLUB_GDPR_FILE,
    variables: { fileName: file.name, size: file.size, club: clubId, uploadType: "clubGdpr" },
  });
  const ticket = response.data.data.uploadFile;
  try {
    const upload = JSON.parse(ticket.uploadData);
    const form = new FormData();
    Object.entries(upload.fields).forEach(([key, value]) => form.append(key, value));
    form.append("file", file);
    const uploaded = await post(upload.url, { method: "POST", body: form });
    if (!uploaded.ok) throw new Error("gdpr_document_upload_failed");

    const completed = await graphql({
      query: COMPLETE_CLUB_GDPR_UPLOAD,
      variables: { fileId: ticket.fileId },
    });
    const document = completed.data.data.completeClubGdprUpload;
    if (!document?.url) throw new Error("gdpr_document_upload_failed");
    return document;
  } catch (error) {
    try {
      // This endpoint cancels pending uploads only. A lost completion response
      // must never cause the newly published policy to be deleted.
      await graphql({ query: CANCEL_CLUB_GDPR_UPLOAD, variables: { fileId: ticket.fileId } });
    } catch (cleanupError) {
      onCleanupError?.(cleanupError);
    }
    throw error;
  }
}
